import { useEffect } from 'react';

// レンダリング時スクロール位置を上にする
export const useLayout = (): void => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};
